<template>
    <div>
        <main-title title="Mis compras en curso" />
        <b-table
        v-if="shopList.length > 0" 
        :items="shopList" 
        :fields="[
            { key: 'id', label: 'Número de orden'},
            { key: 'workflowname', label: 'Tipo' },
            { key: 'progress', label: 'Estado' },
            { key: 'countproducts', label: 'Productos' },
            { key: 'updated', label: 'Actualizado' },
            { key: '_actions', label: 'Detalles' },
        ]"
        responsive
      >
      <template v-slot:cell(progress)="data">
        <b-progress
          :value="data.item.stepposition"
          :max="data.item.totalsteps"
          height=".5rem"
        ></b-progress>
        <div class="text-center" style="font-size: 0.75rem">
          <b>{{ data.item.stepname }}</b
          ><br />
          <small
            ><em>{{ data.item.statusname }}</em></small
          >
        </div>
      </template>
      <template v-slot:cell(_actions)="data">
        <b-button
          variant="outline-primary"
          class="rounded-circle border-0"
          v-b-tooltip.hover
          title="Ver detalles"
          @click="detailTitle= data.item.workflowname; detailCode= data.item.tracknumber; showDetails(data.item.id, data.item.workflow, data.item.step)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-alt" width="1rem" heigth="1rem" class="svg-inline--fa fa-file-alt fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"/></svg>
        </b-button>
      </template>
      </b-table>
      <div
        class="m-3 p-5 rounded text-center"
        style="background: #f1f1f1;"
        v-else
        >
        No tienes compras en curso
        </div>
        <main-title title="Mis compras completadas" />
        <b-table
        v-if="shopListComplete.length > 0" 
        :items="shopListComplete" 
        :fields="[
            { key: 'id', label: 'Número de orden'},
            { key: 'workflowname', label: 'Tipo' },
            { key: 'countproducts', label: 'Productos' },
            { key: 'statusname', label: 'Resultado' },
            { key: 'updated', label: 'Actualizado' },
            { key: '_actions', label: 'Detalles' },
        ]"
        responsive
      >      
      <template v-slot:cell(_actions)="data">
        <b-button
          variant="outline-primary"
          class="rounded-circle border-0"
          v-b-tooltip.hover
          @click="detailTitle = data.item.workflowname; detailCode= data.item.tracknumber; showDetails(data.item.id, data.item.workflow, data.item.step)"
          title="Ver detalles"
        >
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-alt" width="1rem" heigth="1rem" class="svg-inline--fa fa-file-alt fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"/></svg>
        </b-button>
      </template>
      </b-table>
      <div
        class="m-3 p-5 rounded text-center"
        style="background: #f1f1f1;"
        v-else
        >
        No tienes compras completadas
        </div>
        <b-modal id="modal-order" :title="detailTitle" size="lg" hide-footer>
            <div
                class="d-flex justify-content-center flex-column flex-md-row align-items-center w-100 border p-3 bg-light"
            >
                <div v-for="(item, index) in steps" :key="index">
                <div v-if="item" class="d-flex align-items-center">
                    <div
                    class="rounded bg-success text-white shadow p-1"
                    v-if="index < steporder"
                    >
                    {{ item.name }}
                    </div>
                    <div
                    class="rounded text-white shadow p-1"
                    style="background: var(--crujia)"
                    v-else-if="index == steporder"
                    >
                    {{ item.name }}
                    </div>
                    <div class="rounded bg-secondary text-white shadow p-1" v-else>
                    {{ item.name }}
                    </div>
                    <div
                    class="shadow d-none d-md-block"
                    style="
                        width: 1.5rem;
                        height: 0.25rem;
                        background: linear-gradient(0deg, #999, #bbb, #999);
                    "
                    v-if="index < steps.length - 1"
                    ></div>
                </div>
                </div>
            </div>
            <div v-if="detailCode">
                <b-form-group
                label="Código de seguimiento de envío"
                label-for="tracknumber"
              >
                <b-form-input
                  id="tracknumber"
                  disabled
                  v-model="detailCode"
                ></b-form-input>
              </b-form-group>
            </div>
            <b-table
                :items="productList" 
                :fields="[
                    { key: 'quantity', label: 'Cantidad'},
                    { key: 'productname', label: 'Producto' },
                    { key: 'cost', label: 'Precio U.' },
                    { key: 'total', label: 'Total' },
                ]"
                foot-clone
                responsive
            >
            <template v-slot:cell(total)="data">
                $ {{data.item.total}}
            </template> 
            <template v-slot:cell(cost)="data">
                $ {{data.item.cost}}
            </template>
            <template #foot(cost)>
                <b>Total</b>
            </template>
            <template #foot(total)>
                <b>$ {{prodTotal}}</b>
            </template>
            <template #foot()><div></div></template>  
            </b-table>
        </b-modal>
    </div>    
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import axios from "axios";

export default {
    components: {
        MainTitle,
    },
    data(){
        return{
            shopList: [],
            shopListComplete: [],
            productList: [],
            steps:[],
            prodTotal: 0,
            step: 0,
            detailTitle: '',
            detailCode: ''
        }
    },
    mounted(){
        if (!this.$store.state.user.isLogged){
           this.$router.push({name: 'NoLogin', params: {source: 'compras'}});
        }else{
            this.getShops();
        }
    },
    methods:{
        async getShops(){
            await axios.post(
                    this.$store.state.user.siteData.location + 'orders/orders/find',
                    JSON.stringify({client: this.$store.state.user.usrid, close: 0}),
                    {
                    validateStatus(status) {
                        return status < 500 // Resolve only if the status code is less than 500
                    },
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token,
                        'Content-Type': 'application/json',
                    },
                    }
                )
                .then(evtResponse => {
                    console.log(evtResponse.data);
                    this.shopList = [];
                    const items = evtResponse.data.records
           
                    this.shopList = items;

                });
            await axios.post(
                    this.$store.state.user.siteData.location + 'orders/orders/find',
                    JSON.stringify({client: this.$store.state.user.usrid, close: 1}),
                    {
                    validateStatus(status) {
                        return status < 500 // Resolve only if the status code is less than 500
                    },
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token,
                        'Content-Type': 'application/json',
                    },
                    }
                )
                .then(evtResponse => {
                    console.log(evtResponse.data);
                    this.shopListComplete = [];
                    const items = evtResponse.data.records
           
                    this.shopListComplete = items;

                });
        },
        async showDetails(orderId, workflow, step){   
            
            this.step = step;

            this.steps = await axios
                                .post(
                                this.$store.state.user.siteData.location + 'workflows/workflow_steps/find',
                                JSON.stringify({ workflow: workflow }),
                                {
                                    validateStatus(status) {
                                    return status < 500 // Resolve only if the status code is less than 500
                                    },
                                    headers: {
                                    'Content-Type': 'application/json',
                                    },
                                }
                                )
                                .then((evtResponse) => {
                               
                                    const items = evtResponse.data.records
                                    const result = []
                                    items.forEach((element) => {
                                    result[parseInt(element.position)] = element
                                    if (this.step === element.id) {
                                        this.steporder = parseInt(element.position)
                                    }
                                    })

                                    return result
                                
                                })
                                .catch((error) => {
                                // Here we could override the busy state, setting isBusy to false
                                // this.isBusy = false
                                // Returning an empty array, allows table to correctly handle
                                // internal busy state in case of error
                                console.log(error)
                                return []
                                });



            await axios.post(
                    this.$store.state.user.siteData.location + 'orders/products/find',
                    JSON.stringify({orderid: orderId}),
                    {
                    validateStatus(status) {
                        return status < 500 // Resolve only if the status code is less than 500
                    },
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token,
                        'Content-Type': 'application/json',
                    },
                    }
                )
                .then(evtResponse => {
                    console.log(evtResponse.data);
                    this.productList = [];
                    this.prodTotal = 0;
                    const items = evtResponse.data.records
           
                    this.productList = items;
                    
                    items.forEach(element => {
                        this.prodTotal += parseInt(element.total);
                    });

                    this.$bvModal.show('modal-order');
                });
            
            
            
        }
    }
}
</script>